import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <section className="contact" id="main" role="main">
      <div className="container">
        <div className="section-header" style={{ marginBottom: 32 }}>
          <h1 style={{ color: 'var(--primary-color)', marginBottom: 24 }}>
            Regulamin Korzystania z Usług
          </h1>
          <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>
            Ostatnia aktualizacja: 10 sierpnia 2025
          </p>
        </div>

        <div className="contact-form" style={{ maxWidth: 900, margin: '0 auto', textAlign: 'left' }}>
          
          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 1. Postanowienia ogólne
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>1.1.</strong> Niniejszy Regulamin określa zasady świadczenia usług przez 
                <strong> Jasne Granty</strong> z siedzibą w Warszawie przy ul. Przykładowej 1, 
                00-001 Warszawa, e-mail: kontakt@jasnegranty.pl, tel. +48 123 456 789.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>1.2.</strong> Regulamin obowiązuje wszystkich Klientów korzystających z usług 
                świadczonych przez Jasne Granty, zarówno na podstawie umów pisemnych, jak i zamówień 
                składanych drogą elektroniczną.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>1.3.</strong> Korzystanie z usług Jasne Granty oznacza akceptację niniejszego 
                Regulaminu w całości.
              </p>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 2. Definicje
            </h2>
            <ul style={{ paddingLeft: 24 }}>
              <li style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>Usługodawca</strong> – Jasne Granty, świadczący usługi doradcze i przygotowywania wniosków o dofinansowanie
              </li>
              <li style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>Klient</strong> – osoba fizyczna, prawna lub jednostka organizacyjna korzystająca z usług
              </li>
              <li style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>Usługi</strong> – wszystkie usługi oferowane przez Jasne Granty, w tym pisanie wniosków grantowych, 
                biznesplanów, doradztwo, szkolenia, zarządzanie projektami i fundraising
              </li>
              <li style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>Projekt</strong> – zamierzenie inwestycyjne lub operacyjne Klienta, dla którego poszukiwane 
                jest zewnętrzne finansowanie
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 3. Zakres usług
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>3.1.</strong> Jasne Granty świadczy następujące usługi:
              </p>
              <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Pisanie wniosków o dofinansowanie z programów krajowych i unijnych</li>
                <li style={{ marginBottom: 8 }}>Przygotowywanie biznesplanów i studiów wykonalności</li>
                <li style={{ marginBottom: 8 }}>Doradztwo strategiczne w zakresie pozyskiwania finansowania</li>
                <li style={{ marginBottom: 8 }}>Szkolenia i warsztaty z pisania wniosków</li>
                <li style={{ marginBottom: 8 }}>Zarządzanie projektami dofinansowanymi</li>
                <li style={{ marginBottom: 8 }}>Usługi fundraisingowe</li>
                <li style={{ marginBottom: 8 }}>Audyt organizacyjny i optymalizacja procesów</li>
              </ul>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>3.2.</strong> Szczegółowy zakres każdej usługi określa indywidualna umowa 
                lub potwierdzenie zamówienia.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>3.3.</strong> Usługodawca zastrzega sobie prawo do odmowy świadczenia usług 
                w przypadkach, gdy projekt nie spełnia kryteriów kwalifikowalności lub jest sprzeczny 
                z przepisami prawa.
              </p>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 4. Zawieranie umów
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>4.1.</strong> Proces współpracy rozpoczyna się od bezpłatnej konsultacji 
                wstępnej, podczas której oceniana jest wykonalność projektu.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>4.2.</strong> Oferta cenowa przedstawiona Klientowi wiąże Usługodawcę przez 30 dni.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>4.3.</strong> Umowa zostaje zawarta poprzez:
              </p>
              <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Podpisanie umowy pisemnej, lub</li>
                <li style={{ marginBottom: 8 }}>Potwierdzenie zamówienia drogą elektroniczną i wpłacenie zaliczki</li>
              </ul>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>4.4.</strong> Rozpoczęcie prac następuje po:
              </p>
              <ul style={{ paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Podpisaniu umowy</li>
                <li style={{ marginBottom: 8 }}>Wpłaceniu wymaganej zaliczki</li>
                <li style={{ marginBottom: 8 }}>Dostarczeniu przez Klienta niezbędnych materiałów</li>
              </ul>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 5. Obowiązki stron
            </h2>
            
            <div style={{ marginBottom: 24 }}>
              <h3 style={{ fontSize: '1.125rem', marginBottom: 12, color: 'var(--primary-color)' }}>
                5.1. Obowiązki Usługodawcy:
              </h3>
              <ul style={{ paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Świadczenie usług z należytą starannością i zgodnie z aktualnym stanem wiedzy</li>
                <li style={{ marginBottom: 8 }}>Zachowanie poufności otrzymanych informacji</li>
                <li style={{ marginBottom: 8 }}>Dotrzymanie uzgodnionych terminów realizacji</li>
                <li style={{ marginBottom: 8 }}>Informowanie o istotnych zmianach w regulaminach konkursów</li>
                <li style={{ marginBottom: 8 }}>Zapewnienie jakości świadczonych usług zgodnie z systemem QA/QA+</li>
              </ul>
            </div>

            <div>
              <h3 style={{ fontSize: '1.125rem', marginBottom: 12, color: 'var(--primary-color)' }}>
                5.2. Obowiązki Klienta:
              </h3>
              <ul style={{ paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Dostarczenie kompletnych i prawdziwych informacji o projekcie</li>
                <li style={{ marginBottom: 8 }}>Przekazanie niezbędnej dokumentacji w uzgodnionych terminach</li>
                <li style={{ marginBottom: 8 }}>Terminowe regulowanie należności</li>
                <li style={{ marginBottom: 8 }}>Współpraca przy weryfikacji przygotowanych dokumentów</li>
                <li style={{ marginBottom: 8 }}>Informowanie o zmianach wpływających na realizację projektu</li>
                <li style={{ marginBottom: 8 }}>Samodzielne złożenie wniosku (chyba że uzgodniono inaczej)</li>
              </ul>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 6. Wynagrodzenie i płatności
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>6.1.</strong> Wysokość wynagrodzenia określa indywidualna umowa lub potwierdzenie zamówienia.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>6.2.</strong> Standardowy harmonogram płatności:
              </p>
              <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>50% wynagrodzenia – zaliczka przy podpisaniu umowy</li>
                <li style={{ marginBottom: 8 }}>50% wynagrodzenia – przy przekazaniu gotowego wniosku</li>
              </ul>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>6.3.</strong> Płatności dokonywane są na podstawie wystawionych faktur VAT.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>6.4.</strong> Termin płatności wynosi 14 dni od daty wystawienia faktury.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>6.5.</strong> W przypadku opóźnienia w płatności, Usługodawca może:
              </p>
              <ul style={{ paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Naliczać odsetki ustawowe za zwłokę</li>
                <li style={{ marginBottom: 8 }}>Wstrzymać dalsze prace nad projektem</li>
                <li style={{ marginBottom: 8 }}>Odstąpić od umowy z winy Klienta</li>
              </ul>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 7. Gwarancje i odpowiedzialność
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>7.1.</strong> Usługodawca gwarantuje:
              </p>
              <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Zgodność wniosku z wymogami formalnymi programu</li>
                <li style={{ marginBottom: 8 }}>Wysoką jakość merytoryczną dokumentów</li>
                <li style={{ marginBottom: 8 }}>Dotrzymanie uzgodnionych terminów</li>
              </ul>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>7.2.</strong> Usługodawca nie gwarantuje otrzymania dofinansowania – decyzja 
                należy do instytucji oceniającej.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>7.3.</strong> Odpowiedzialność Usługodawcy za szkody ograniczona jest do wysokości 
                wynagrodzenia za daną usługę.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>7.4.</strong> Usługodawca nie ponosi odpowiedzialności za:
              </p>
              <ul style={{ paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Odrzucenie wniosku z przyczyn leżących po stronie Klienta</li>
                <li style={{ marginBottom: 8 }}>Zmiany w regulaminach konkursów po złożeniu wniosku</li>
                <li style={{ marginBottom: 8 }}>Błędy wynikające z nieprawdziwych informacji od Klienta</li>
                <li style={{ marginBottom: 8 }}>Szkody pośrednie i utracone korzyści</li>
              </ul>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 8. Własność intelektualna
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>8.1.</strong> Przygotowane dokumenty stają się własnością Klienta po pełnym 
                uregulowaniu należności.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>8.2.</strong> Usługodawca zachowuje prawo do wykorzystania ogólnych rozwiązań 
                i metodologii w innych projektach.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>8.3.</strong> Klient wyraża zgodę na wykorzystanie anonimowych danych o projekcie 
                w materiałach marketingowych (po wcześniejszym uzgodnieniu).
              </p>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 9. Odstąpienie od umowy
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>9.1.</strong> Klient może odstąpić od umowy bez podania przyczyny w terminie 14 dni 
                od jej zawarcia, jeśli prace nie zostały jeszcze rozpoczęte.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>9.2.</strong> Po rozpoczęciu prac Klient może odstąpić od umowy za 14-dniowym 
                wypowiedzeniem, płacąc wynagrodzenie proporcjonalne do wykonanych prac.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>9.3.</strong> Usługodawca może odstąpić od umowy w przypadku:
              </p>
              <ul style={{ paddingLeft: 24 }}>
                <li style={{ marginBottom: 8 }}>Opóźnienia w płatnościach przekraczającego 30 dni</li>
                <li style={{ marginBottom: 8 }}>Braku współpracy ze strony Klienta uniemożliwiającej realizację</li>
                <li style={{ marginBottom: 8 }}>Istotnych zmian w regulaminie konkursu</li>
              </ul>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 10. Ochrona danych osobowych
            </h2>
            <p style={{ marginBottom: 16, lineHeight: 1.6 }}>
              <strong>10.1.</strong> Szczegółowe informacje o przetwarzaniu danych osobowych zawarte 
              są w <Link to="/polityka-prywatnosci" style={{ color: 'var(--secondary-color)' }}>Polityce Prywatności</Link>.
            </p>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 11. Rozstrzyganie sporów
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>11.1.</strong> Strony będą dążyć do polubownego rozstrzygania wszelkich sporów.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>11.2.</strong> W przypadku niemożności osiągnięcia porozumienia, spory będą 
                rozstrzygane przez sąd właściwy dla siedziby Usługodawcy.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>11.3.</strong> Do umów stosuje się prawo polskie.
              </p>
            </div>
          </section>

          <section style={{ marginBottom: 2, padding: 16 }}>
            <h2 style={{ marginBottom: 16, color: 'var(--primary-color)' }}>
              § 12. Postanowienia końcowe
            </h2>
            <div style={{ marginBottom: 16 }}>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>12.1.</strong> Regulamin może być zmieniony przez Usługodawcę. Zmiany nie 
                dotyczą już zawartych umów.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>12.2.</strong> O planowanych zmianach Klienci będą informowani z 30-dniowym 
                wyprzedzeniem.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>12.3.</strong> W sprawach nieuregulowanych w niniejszym Regulaminie stosuje 
                się przepisy Kodeksu cywilnego.
              </p>
              <p style={{ marginBottom: 12, lineHeight: 1.6 }}>
                <strong>12.4.</strong> Regulamin wchodzi w życie z dniem 10 sierpnia 2025 roku.
              </p>
            </div>
          </section>

          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 40 }}>
            <Link to="/" className="btn btn-primary">Strona główna</Link>
            <Link to="/blog" className="btn btn-outline">Blog</Link>
            <Link to="/polityka-prywatnosci" className="btn btn-outline">Polityka Prywatności</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
